// Imports: local files.
import {
  GET_TECHNIQUES_START,
  GET_TECHNIQUES_SUCCESS,
  GET_TECHNIQUES_FAILED,
  GET_TECHNIQUES_RESET,
  GET_TECHNIQUE_START,
  GET_TECHNIQUE_SUCCESS,
  GET_TECHNIQUE_FAILED,
  GET_TECHNIQUE_RESET,
  CREATE_TECHNIQUE_START,
  CREATE_TECHNIQUE_SUCCESS,
  CREATE_TECHNIQUE_FAILED,
  CREATE_TECHNIQUE_RESET,
  UPDATE_TECHNIQUE_START,
  UPDATE_TECHNIQUE_SUCCESS,
  UPDATE_TECHNIQUE_FAILED,
  UPDATE_TECHNIQUE_RESET,
  DELETE_TECHNIQUE_START,
  DELETE_TECHNIQUE_SUCCESS,
  DELETE_TECHNIQUE_FAILED,
  DELETE_TECHNIQUE_RESET,
} from '../actions';

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};
const initialState = {
  getAll: initialLoadingState,
  getOne: initialLoadingState,
  create: initialLoadingState,
  updateOne: initialLoadingState,
  deleteOne: initialLoadingState,
};

const techniquesReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get All Techniques
     * =======================================================================
     */
    case GET_TECHNIQUES_START:
      return { ...state, getAll: { ...action.payload } };
    case GET_TECHNIQUES_SUCCESS:
      return { ...state, getAll: { ...action.payload } };
    case GET_TECHNIQUES_FAILED:
      return { ...state, getAll: { ...action.payload } };
    case GET_TECHNIQUES_RESET:
      return { ...state, getAll: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get One Technique
     * =======================================================================
     */
    case GET_TECHNIQUE_START:
      return { ...state, getOne: { ...action.payload } };
    case GET_TECHNIQUE_SUCCESS:
      return { ...state, getOne: { ...action.payload } };
    case GET_TECHNIQUE_FAILED:
      return { ...state, getOne: { ...action.payload } };
    case GET_TECHNIQUE_RESET:
      return { ...state, getOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Create Technique
     * =======================================================================
     */
    case CREATE_TECHNIQUE_START:
      return { ...state, create: { ...action.payload } };
    case CREATE_TECHNIQUE_SUCCESS:
      return { ...state, create: { ...action.payload } };
    case CREATE_TECHNIQUE_FAILED:
      return { ...state, create: { ...action.payload } };
    case CREATE_TECHNIQUE_RESET:
      return { ...state, create: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Update One Technique
     * =======================================================================
     */
    case UPDATE_TECHNIQUE_START:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_TECHNIQUE_SUCCESS:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_TECHNIQUE_FAILED:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_TECHNIQUE_RESET:
      return { ...state, updateOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Delete One Technique
     * =======================================================================
     */
    case DELETE_TECHNIQUE_START:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_TECHNIQUE_SUCCESS:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_TECHNIQUE_FAILED:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_TECHNIQUE_RESET:
      return { ...state, deleteOne: { ...initialLoadingState } };
    default:
      return state;
  }
};

export default techniquesReducer;
